export enum BillsShowModeType {
    Normal = 0,
    SummaryElementsSelection = 1,
    Vat = 2,
    VatSelection = 3
}